<template>
  <div class="waitinfopage">
    <div class="payname">
      <div class>
        <span>{{userinfo.Name}}</span>
        <span>{{userinfo.CardNumber}}</span>
        <span class="cor" @click="swith()">切换就诊人</span>
        <span class="needle">></span>
      </div>
    </div>
    <div class="waitinfo" v-for="item in referralList" v-show="isShow">
      <div>
        <p class="infotit">
          <img src="../../assets/images/waiting.png" alt>
          <span>{{item.DptName}}（{{item.DctName}}）</span>
          <span class="singIn" @click="hasshowfun(item)">签到</span>
        </p>
        <div class="inforcodebox">
          <p class="font40">
            <span>{{item.WaitNumber}}人</span>
          </p>
          <p class="center">
            <span>前面还有</span>
          </p>
        </div>
        <div class="pt20">
          <div class="container">
            <div>
              <span>就诊人：</span>
              <span>{{item.Name}}</span>
            </div>
            <div class="ml">
              <span>就诊号：</span>
              <span>{{item.Code}}</span>
            </div>
          </div>
          <div class="container">
            <div>
              <span>您的号码为：</span>
              <span class="corred">{{item.Sort}}</span>
            </div>
            <div class="ml">
              <span>就诊日期:</span>
              <span>{{item.VisitTime}}</span>
            </div>
          </div>
          <div class="container">
            <div>
              <span>预计就诊时间：</span>
              <span>{{item.EstimatedTime}}</span>
            </div>
            <div>
              <span class="cor66">实际时间以叫号为准</span>
            </div>
          </div>

          <p>
            <span>就诊地点：</span>
            <span>{{item.Address}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="noDate" v-show="!isShow">
      <div v-show="true" class="nolist">
        <!-- 无数据显示 -->
        <img src="../../assets/images/searchbg.png" alt class="searchpic">
        <p class="center">暂无数据</p>
      </div>
    </div>
    <!-- 遮罩弹窗 -->
    <div class="popContainer" v-show="isshow">
      <div class="popcon">
        <div class="topbig"></div>
        <div class="popdeteil">
          <p>{{referralModel.Name}}&nbsp;&nbsp;&nbsp;{{referralModel.Sex}}&nbsp;&nbsp;&nbsp;{{referralModel.StrAge}}</p>
          <p>{{referralModel.PatNo}}&nbsp;&nbsp;&nbsp;{{referralModel.CardNo}}</p>
          <img src="../../assets/images/codedel.png" alt class="codedel" @click="codedelfun">
        </div>
        <div class="popcode">
          <div>
            <img :src="imgUrl" alt>
          </div>
          <p>请凭此二维码到签到台签到</p>
        </div>
      </div>
    </div>
    <!-- 结束 -->
  </div>
</template>
<script>
import weui from "weui.js";
import { GetReferralList } from "@/services/getData.js";
export default {
  name: "waitinformation",
  data() {
    return {
      isshow: false,
      referralList: {},
      referralModel: [],
      imgUrl: "",
      userinfo: {},
      isShow: true
    };
  },
  created: function() {
    this.getReferralList();
    this.userinfo = this.$store.state.userInfo;
  },
  methods: {
    hasshowfun(item) {
      this.referralModel = item;
      this.isshow = !this.isshow;
      this.imgUrl = "http://qr.liantu.com/api.php?&w=200&text=" + item.PatNo;
    },
    codedelfun() {
      this.isshow = false;
    },
    swith() {
      //跳转到切换就诊人页
      this.$router.push({ path: "/card/switchcard" });
    },
    getReferralList() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetReferralList().then(response => {
        loading.hide();
        if (response.data) {
          this.referralList = response.data;
          console.info(this.referralList);
          if (response.data.length > 0) {
            this.isShow = true;
          } else {
            this.isShow = false;
          }
        } else {
        }
      });
    }
  }
};
</script>
<style>

.waitinfopage .payname {
  width: 100%;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  padding: 0 0.2rem;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.8rem;
  box-sizing: border-box;
}

.payname > div {
  position: relative;
}

.waitinfopage .payname .cor {
  color: #feff82 !important;
  float: right;
  margin-right: 0.4rem;
}

.waitinfopage {
  width: 100%;
  height: 100%;
  position: relative;
}

.waitinfopage .waitinfo {
  width: 100%;
  background: white;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  padding: 0.2rem;
  box-sizing: border-box;
  height: auto;
  margin-bottom: 0.2rem;
}

.waitinfopage .waitinfo .infotit {
  position: relative;
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
  font-size: 0.26rem;
  line-height: 0.36rem;
  background-color: white;
  height: auto;
  box-sizing: border-box;
  padding-bottom: 0.13rem;
}

.waitinfopage .waitinfo .infotit > img {
  width: 0.26rem;
  height: 0.32rem;
  display: inline-block;
  vertical-align: bottom;
}

.waitinfopage .waitinfo .infotit .singIn {
  float: right;
  color: #1592e4;
}

.waitinfopage .waitinfo .inforcodebox {
  box-sizing: border-box;
  padding: 0.2rem 0;
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
}

.waitinfopage .waitinfo .inforcodebox .codepic {
  width: 1rem;
  height: 1rem;
  margin: 0 auto;
}

.waitinfopage .waitinfo .inforcodebox .waitdoc {
  font-size: 0.3rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #1592e4;
  text-align: center;
}

.waitinfopage .waitinfo .inforcodebox .explain {
  font-size: 0.2rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  text-align: center;
}

.waitinfopage .waitinfo .pt20 {
  box-sizing: border-box;
  padding-top: 0.2rem;
}

.waitinfopage .waitinfo .container {
  display: flex;
  flex-direction: row;
}

.waitinfopage .waitinfo .container > div {
  flex: 1;
}

.waitinfopage .waitinfo .corred {
  color: #ef5353 !important;
}

.waitinfopage .waitinfo .inforcodebox .ml {
  margin-left: -0.5rem;
}

.waitinfopage .waitinfo .cor66 {
  color: #666666 !important;
}

.waitinfopage .waitinfo .font40 {
  font-size: 0.4rem !important;
  text-align: center;
}

.waitinfopage .waitinfo .center {
  text-align: center;
}

/* 遮罩弹窗样式 */
div.popContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}

.popContainer .popcon {
  width: 4.19rem;
  height: 5.21rem;
  background-color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -2.08rem;
  margin-top: -2.605rem;
}

.popContainer .popcon .topbig {
  width: 100%;
  height: 0.1rem;
  background-color: #1592e4;
}

.popContainer .popcon .popdeteil {
  padding-left: 0.28rem;
  padding-top: 0.23rem;
  font-size: 0.24rem;
  color: #333333;
  border-bottom: 0.01rem solid #dcdcdc;
  padding-bottom: 0.19rem;
  font-family: "MicrosoftYaHei";
}

.popContainer .popcon .popdeteil .codedel {
  position: absolute;
  width: 0.42rem;
  height: 0.42rem;
  right: 0.2rem;
  top: 0.2rem;
}

.popContainer .popcon .popcode {
  text-align: center;
  font-size: 0.2rem;
  color: #333333;
  padding: 0.32rem 0.64rem 0.1rem 0.63rem;
}

.popContainer .popcon .popcode img {
  display: inline-block;
  width: 2.92rem;
  height: 2.92rem;
}

/* 遮罩弹窗样式 结束*/
</style>




// WEBPACK FOOTER //
// src/components/waitinginfo/waitinformation.vue